import BaseComponent from 'components/pages/MonthlyTotalAsset';
import {
  getMonthlyTotalAssets,
  deleteMonthlyTotalAsset,
  postMonthlyTotalAsset,
} from 'domains/api/monthly_total_assets';
import { resetCurrentUser } from 'domains/current_user';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import * as Types from 'types';

const MonthlyTotalAsset: React.FC = () => {
  const navigate = useNavigate();

  const [reload, setReload] = useState<boolean>(false);
  const [monthlyTotalAssets, setMonthlyTotalAssets] = useState<
    Types.MonthlyTotalAsset[]
  >([]);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    setIsLoading(true);
    void getMonthlyTotalAssets()
      .then((response) => {
        setMonthlyTotalAssets(response.monthly_total_assets);
        setIsLoading(false);
        setReload(false);
      })
      .catch(() => {
        resetCurrentUser();
        navigate('/signIn');
      });
  }, [navigate, reload]);

  const onClickMonthlyTotalAssetUpdate = (
    monthlyTotalAsset: Types.MonthlyTotalAsset,
  ) => {
    navigate(`/monthly_total_assets/${monthlyTotalAsset.id}`);
  };

  const onClickMonthlyTotalAssetDelete = (
    monthlyTotalAsset: Types.MonthlyTotalAsset,
  ) => {
    void deleteMonthlyTotalAsset(monthlyTotalAsset.id)
      .then((_) => {
        setReload(true);
      })
      .catch(() => {
        resetCurrentUser();
        navigate('/signIn');
      });
  };

  const onSubmit = (
    year: number,
    month: number,
    bank: number,
    wallet: number,
  ) => {
    const newMonthlyTotalAsset = { id: -1, year, month, bank, wallet };
    void postMonthlyTotalAsset(newMonthlyTotalAsset)
      .then((_) => {
        setReload(true);
      })
      .catch(() => {
        resetCurrentUser();
        navigate('/signIn');
      });
  };

  return (
    <BaseComponent
      isLoading={isLoading}
      onSubmit={onSubmit}
      monthlyTotalAssets={monthlyTotalAssets}
      onClickMonthlyTotalAssetUpdate={onClickMonthlyTotalAssetUpdate}
      onClickMonthlyTotalAssetDelete={onClickMonthlyTotalAssetDelete}
    />
  );
};

export default MonthlyTotalAsset;
